import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { IonicStorageModule } from '@ionic/storage-angular'
import { InlineSVGModule } from 'ng-inline-svg-2'
import { configureAmplify } from './utils/amplify.config'
import { bootstrapApplication } from '@angular/platform-browser'
import { routes } from './app/app.routes'
import { AppComponent } from './app/app.component'
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router'
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone'
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http'
import { authInterceptor } from './api.interceptor'
import { sentryProviders } from './utils/sentry.config'
import { pageTransitionAnimation } from './utils/page-transition.animation'
import { provideLottieOptions } from 'ngx-lottie'
import 'mapbox-gl/dist/mapbox-gl.css'
import { environment } from './environments/environment'
import 'barcode-detector/polyfill'
import { MOCK_INTERCEPTORS, MOCK_PROVIDERS } from './mocks/mock.providers'
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient)
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideLottieOptions({
      player: () => import(/* webpackChunkName: 'lottie-web' */ 'lottie-web'),
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      innerHTMLTemplatesEnabled: true,
      mode: 'ios',
      navAnimation: pageTransitionAnimation,
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    ...sentryProviders,
    importProvidersFrom(
      IonicStorageModule.forRoot({}),
      InlineSVGModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideHttpClient(withInterceptors([...MOCK_INTERCEPTORS, authInterceptor])),
    ...MOCK_PROVIDERS,
  ],
})
configureAmplify(environment.production)
